// extracted by mini-css-extract-plugin
module.exports = {"container":"Chips_container__1jkhk","chip":"Chips_chip__ZL_9V"};